import { Pokebola } from "./Pokebola";
import usePokemons from "../utils/usePokemons";
import { useEffect, useState } from "react";
import { IconX } from "@tabler/icons-react";
import { useMediaQuery } from "react-responsive";
export const SearchInput = ({
  pokemonName,
  onCleanFilter,
  handleOnChangeSearch,
}) => {
  const [randomPokemon, setRandomPokemon] = useState(null);
  const [randomUrlData, setRandomUrlData] = useState(null); //aqui se obtiene la imagen de referencia
  const [isThrowing, setIsThrowing] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [revealedSiluet, setRevealedSiluet] = useState(false);
  const [revealedX, setRevealedX] = useState(false);

  const [contador, setContador] = useState(null);
  const { pokemonsUtils: allPokemons } = usePokemons();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  function getRandomPokemon(pokemonList) {
    const randomIndex = Math.floor(Math.random() * pokemonList.length);
    return pokemonList[randomIndex];
  }
  function SetRandomPokemon() {
    const randomPoke = getRandomPokemon(allPokemons);
    setRandomPokemon(randomPoke); // actualiza el estado para el render

    if (!randomPoke?.url) return;

    const fetchPokemonURL = async () => {
      try {
        const responseURL = await fetch(randomPoke.url); // usamos el que ya tenemos
        const dataURL = await responseURL.json();
        if (dataURL) setRandomUrlData(dataURL);
      } catch (error) {
        console.error("Error fetching Pokémon data:", error);
      }
    };

    fetchPokemonURL();
  }

  function SiluetRevealed() {
    //hace que la saturación de la imagen desaparezca
    setRevealedSiluet(true);
  }
  function CloseModalPokemon() {
    setRevealed(false);
    setRevealedSiluet(false); //vuelve a poner el efecto sombra en la imagen
  }
  const HandleRandomPokemon = (e) => {
    e.preventDefault();
    setIsThrowing(true);
    SetRandomPokemon();
    setRevealedX(false);
    setTimeout(() => {
      setRevealed(true); //abre el  modal
      setContador(4);
      setIsThrowing(false);
    }, 800);
  };
  useEffect(() => {
    if (contador === null) return;

    if (contador > 0) {
      const intervalo = setInterval(() => {
        setContador((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(intervalo);
    } else if (contador === 0) {
      // Cuando termina el contador
      SiluetRevealed();
      setRevealedX(true);
    }
  }, [contador, allPokemons]);
  return (
    <form id="formulario-search">
      <input
        value={pokemonName}
        onChange={(e) => {
          onCleanFilter();
          handleOnChangeSearch(e);
        }}
        name="pokemonName"
        className="search-input"
        type="text"
        autoComplete="off"
        placeholder="Who is that Pokémon..."
      />
      <button onClick={HandleRandomPokemon} className="search-button">
        <Pokebola animate={isThrowing} /> {/*  Función random pokemon */}
      </button>
      {revealed ? (
        <div className="overlay-card">
          {isMobile ? (
            <div className="pokemon-logo">
              <img
                style={{ width: "100%" }}
                title="pokemon"
                alt="pokemon"
                src="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fpokemon-letter.png?alt=media&token=37ee4f2c-dd0f-4fb6-b226-94950c416d8f"
              />
            </div>
          ) : (
            <></>
          )}
          <button
            onClick={CloseModalPokemon}
            className={
              isMobile
                ? !revealedX
                  ? "closeX"
                  : "closeRevealed"
                : "closeRevealed"
            }
          >
            <IconX size={28} color={isMobile ? "gray" : "white"} />
          </button>
          <div
            className={`card-revealed ${
              isMobile ? "slide-top-card" : "scale-up-centerCard"
            }`}
          >
            <img
              className="guessWhoBackground"
              alt="fondo-pokemon"
              src="https://static0.gamerantimages.com/wordpress/wp-content/uploads/2022/05/whos-that-pokemon.jpg"
            />
            <div className="siluet ">
              <img
                src={randomUrlData?.sprites?.other?.home?.front_default}
                alt="Silueta del Pokémon"
                className={
                  revealedSiluet
                    ? "saturation-full shadow-image"
                    : "saturation shadow-image"
                }
              />
            </div>
          </div>
          <div className="flex-who ">
            {!revealedSiluet ? (
              <>
                <p className="who">Who is that pokémon?</p>
                <span className="contador">{contador}</span>
              </>
            ) : (
              <div className="scale-up-hor-center">
                <p className="who is-pokemon">
                  IS {randomPokemon?.name.toUpperCase()}
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </form>
  );
};

export default SearchInput;
